// DefendantDialog.jsx
import React, {useState} from 'react';
import {Button, Dialog, DialogContent, DialogTitle, IconButton} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import DefendantForm from './DefendantForm';
import {useClient} from "../core/client";

const ALLOWED_DEFENDANT_UPDATE_FIELDS = [
    'first',
    'last',
    'dob',
    'phone',
    'email',
    'address',
    'city',
    'state',
    'zip',
    'status',
    'checkinSchedules',
];

const buildDefendantUpdatePayload = (payload) =>
    ALLOWED_DEFENDANT_UPDATE_FIELDS.reduce((acc, key) => {
        if (payload?.[key] !== undefined) {
            acc[key] = payload[key];
        }
        return acc;
    }, {});

const DefendantDialog = ({ open: controlledOpen, onClose: controlledOnClose, trigger, defendant, onSaved }) => {
	const [internalOpen, setInternalOpen] = useState(false);
	const open = controlledOpen !== undefined ? controlledOpen : internalOpen;
	const client = useClient();
    const isControlled = controlledOpen !== undefined || typeof controlledOnClose === 'function';
    const shouldRenderDefaultTrigger = !trigger && !isControlled;

	const handleClickOpen = () => {
		if (typeof controlledOnClose === 'function') {
			controlledOnClose(true);
		} else {
			setInternalOpen(true);
		}
	};

	const handleClose = () => {
		if (typeof controlledOnClose === 'function') {
			controlledOnClose(false);
		} else {
			setInternalOpen(false);
		}
	};

	const handleFormSubmit = async (formData) => {
	    try {
            const { data } = defendant?.id
                ? await client.put(`/defendants/${defendant.id}`, buildDefendantUpdatePayload(formData))
                : await client.post('/defendants', formData);
            onSaved?.(data);
            handleClose();
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div>
            {trigger && React.cloneElement(trigger, { onClick: handleClickOpen })}
            {shouldRenderDefaultTrigger && (
                <Button
                    variant="contained"
                    startIcon={<AddIcon />}
                    sx={{ color: 'common.white' }}
                    onClick={handleClickOpen}
                >
                    Add Defendant
                </Button>
            )}
            <Dialog open={!!open} onClose={handleClose} maxWidth="sm" fullWidth>
                <DialogTitle
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderBottom: 1,
                        borderColor: 'divider',
                        pb: 2,
                    }}
                >
                    {defendant ? 'Edit Defendant' : 'Add New Defendant'}
                    <IconButton onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <DefendantForm
                        onSubmit={handleFormSubmit}
                        initialValues={defendant}
                        submitLabel={defendant ? 'Save Changes' : 'Add Defendant'}
                        disablePaper
                    />
                </DialogContent>
            </Dialog>
        </div>
    );
};

export default DefendantDialog;
